<template>
  <component
    :is="child"
    v-for="(child, index) in $slots.default?.()"
    :key="index"
    ref="childComponent"
    @input="validateSchema"
  ></component>
  <ul v-if="errors.length > 0" class="list-disc px-6 pt-3">
    <li v-for="error in errors" :key="error">
      <p class="text-red-600 text-sm mb-2">
        {{ error }}
      </p>
    </li>
  </ul>
</template>

<script setup lang="ts">
// Import Vue Packages
import { ref, onMounted } from 'vue'

// Import Vue Component
import { eventEmitter } from 'src/utils/eventsEmitters'

// Define Variables
const errors = ref([])
const isValid = ref(null)
const props = defineProps<{
  schema?: any
  dataValidationId?: string
  pageLang?: string
  pageDir?: string
}>()
const childComponent: any = ref(null)

const validateSchema = (event: any) => {
  errors.value = []
  if (!props.schema) return

  isValid.value = props.schema.validate(event.target.value)
  if (!isValid.value) {
    childComponent.value[0].classList.replace(
      'border-secondary-400',
      'border-red-600',
    )
    childComponent.value[0].classList.replace(
      'border-green-400',
      'border-red-600',
    )
    errors.value = props.schema.getErrors()
  } else {
    childComponent.value[0].classList.replace(
      'border-secondary-400',
      'border-green-400',
    )
    childComponent.value[0].classList.replace(
      'border-red-600',
      'border-green-400',
    )
  }
}

// Hooks
onMounted(() => {
  if (props.dataValidationId) {
    const emitterEventType = `VValidator-${props.dataValidationId}`
    eventEmitter.on(emitterEventType, (event: string) => {
      errors.value = JSON.parse(event)
    })

    eventEmitter.on('resetValidation', () => {
      errors.value = []
    })
  }
})
</script>
